import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from './widget-app/router';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './app/styles.css';
import { initEmbedParentBridge } from './widget-lib/embed-parent-bridge';
import { initDeviceIdBridge } from './widget-lib/device-id-bridge';
import { initEmbedBackBridge } from './widget-lib/embed-back-bridge';

initEmbedParentBridge();
initDeviceIdBridge();
initEmbedBackBridge(router);

// Авто-восстановление после деплоя: при ошибке загрузки динамического чанка Vite эмитит
// `vite:preloadError` — один раз перезагружаем страницу (анти-петля: не чаще раза в 10с).
const CHUNK_RELOAD_TS = 'domcrm-embed-chunk-reload-ts';
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(CHUNK_RELOAD_TS) ?? '0');
  } catch {
    /* sessionStorage может быть недоступен */
  }
  const now = Date.now();
  if (now - last < 10_000) return;
  try {
    sessionStorage.setItem(CHUNK_RELOAD_TS, String(now));
  } catch {
    /* ignore */
  }
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
